/**
 * Bannière de traçabilité — affichée sur tout dossier (Verifier locked / unlocked,
 * dossier spécialiste reçu). Message rassurant et professionnel.
 */
import { ShieldCheck } from "lucide-react";

export default function TraceabilityBanner() {
  return (
    <div
      data-testid="traceability-banner"
      className="flex items-start gap-3 p-3 rounded-sm border border-petrol/25 bg-petrol/[0.04] text-[12px] text-night/80 leading-relaxed"
    >
      <ShieldCheck className="w-4 h-4 text-petrol mt-0.5 shrink-0" />
      <p>
        <b className="text-night">Traçabilité complète</b> — Ce dossier fait l'objet
        d'une journalisation infalsifiable de l'ensemble des accès et actions
        (date, IP, pays, navigateur, niveau d'authentification). Les téléchargements,
        transmissions et consultations sensibles requièrent une réauthentification.
      </p>
    </div>
  );
}
